module.exports = __webpack_public_path__ + "static/media/p5.a5ccc773.jpg";